import { render } from "./AboutUs.vue?vue&type=template&id=076e737a&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=076e737a&lang=scss&scoped=true"

import exportComponent from "/Users/amina/Desktop/streamup_amina/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076e737a"]])

export default __exports__